import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { WealthboxCalendarSyncSettings } from './WealthboxCalendarSyncSettings'
import { WealthboxContactSyncSettings } from './WealthboxContactSyncSettings'

export const WealthboxSpecificSettings = (): ClickNavigationSection[] => {
  return [
    { id: 'contactSync', label: 'Contact Sync', content: () => <WealthboxContactSyncSettings /> },
    { id: 'calendarSync', label: 'Calendar Sync', content: () => <WealthboxCalendarSyncSettings /> },
    { id: 'task', label: 'Task', content: () => <CRMIntegrationTaskSettings serviceId={IntegrationServiceId.WEALTHBOX} /> },
  ]
}
